import { render, staticRenderFns } from "./commonForm.vue?vue&type=template&id=1a4cc3ac&scoped=true"
import script from "./commonForm.vue?vue&type=script&lang=js"
export * from "./commonForm.vue?vue&type=script&lang=js"
import style0 from "./commonForm.vue?vue&type=style&index=0&id=1a4cc3ac&prod&lang=css"
import style1 from "./commonForm.vue?vue&type=style&index=1&id=1a4cc3ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4cc3ac",
  null
  
)

export default component.exports